import template from './eventProductEntry.html';
import controller from './eventProductEntry.controller';

let eventProductEntryComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    position: '<',
    onExit: '&',
  }
};

export default eventProductEntryComponent;
